import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
//import * as crypto from "crypto-js";

//OneLogin
import { finalize } from 'rxjs/operators';
import { AuthService } from '../shared/onelogin/auth.service';
import {SpinnerService} from '../components/generic/spinner/spinner.service';
import { environment } from '../../environments/environment';

@Injectable()
export class HeadersInterceptor implements HttpInterceptor {

  constructor(private __spinnerService: SpinnerService, private __authService: AuthService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let requestToken = request;
    this.__spinnerService.show();

    const user = localStorage.getItem('user')!;
    if (!user) {
      this.__authService.completeAuthentication().then(() => {
        if (this.__authService.isLoggedIn()) {
          //localStorage.setItem('user', crypto.AES.encrypt('jose.puerta@usclaro.com', `${environment.key_api_secret}`).toString());
          //localStorage.setItem('user', crypto.AES.encrypt(this.__authService.user.profile.email!, `${environment.key_api_secret}`).toString());
          localStorage.setItem('user', this.__authService.user.profile.email!);
          localStorage.setItem('token_one', this.__authService.user.id_token!);
          if (!localStorage.getItem('loaded')) {
            localStorage.setItem('loaded', 'true');
            window.location.reload();
          }
        }
      });
    }
    //Agrega header azure microservices
    requestToken = request.clone({
      setHeaders: {
        "Access-Control-Allow-Origin": "*",
        "Ocp-Apim-Subscription-Key": `${environment.key_api_subscription}`
      }
    })
    return next.handle(requestToken).pipe(
      finalize(() => this.__spinnerService.close()));
  }
}
